/**
 * Canonical Application Version
 * Injected at build time by Vite from package.json or environment.
 */
export const APP_VERSION: string =
  (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '') ||
  import.meta.env.VITE_APP_VERSION ||
  '1.37.0';

export default APP_VERSION;
